import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {AdminAlumnoService} from '../services/admin-alumno.service';


@Component({
  selector: 'app-alumnos-examen',
  templateUrl: './alumno-examen.component.html',
  styleUrls: ['../admin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlumnoExamenComponent implements OnInit, OnDestroy {
  public examenes: Array<any> = [];
  public examenesSubscription: Subscription = null;
  public id: number;
  public type: string;
  public order: boolean;
  navLinks = [{}];

  constructor (private route: ActivatedRoute, private router: Router, private _admin: AdminAlumnoService) {
    this._admin.getExamenes(false, 'fecha_e');
  }

  ngOnInit () {
    this.examenesSubscription = this._admin.datos$.subscribe(res => {
      this.examenes = res;
    });
  }

  ngOnDestroy () {
    this.examenesSubscription.unsubscribe();
  }

  ordenar (type: string) {
    this.order = !this.order;
    this._admin.getExamenes(this.order, type);
    }
}

